import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [sp, setSp] = useSearchParams();
  const [loading, setLoading] = useState(true);

  const cat = sp.get("category") || "";
  const sort = sp.get("sort") || "newest";
  const q = sp.get("q") || "";
  const filter = sp.get("filter") || "";

  useEffect(() => { api.get("/categories").then((r) => setCategories(r.data)); }, []);
  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (cat) params.append("category", cat);
    if (sort) params.append("sort", sort);
    if (q) params.append("q", q);
    if (filter === "new") params.append("new_arrival", "true");
    if (filter === "best") params.append("best_seller", "true");
    api.get(`/products?${params}`).then((r) => { setProducts(r.data); setLoading(false); });
  }, [cat, sort, q, filter]);

  const update = (k, v) => { const n = new URLSearchParams(sp); if (v) n.set(k, v); else n.delete(k); setSp(n); };

  return (
    <div className="container-luxe py-16">
      <div className="mb-12">
        <div className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-3">Boutique</div>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight">The Shop</h1>
      </div>
      <div className="flex flex-col lg:flex-row gap-6 mb-10">
        <input data-testid="shop-search" placeholder="Search products…" value={q} onChange={(e) => update("q", e.target.value)} className="max-w-md" />
        <select data-testid="shop-category" value={cat} onChange={(e) => update("category", e.target.value)} className="max-w-xs">
          <option value="">All Categories</option>
          {categories.map((c) => <option key={c.id} value={c.slug}>{c.name}</option>)}
        </select>
        <select data-testid="shop-sort" value={sort} onChange={(e) => update("sort", e.target.value)} className="max-w-xs">
          <option value="newest">Newest</option>
          <option value="popular">Popular</option>
          <option value="alpha">Alphabetical</option>
          <option value="price_asc">Price ↑</option>
          <option value="price_desc">Price ↓</option>
        </select>
      </div>
      {loading ? <div className="text-gray-500">Loading…</div> :
        products.length === 0 ? <div className="text-gray-500 py-20 text-center">No products match your search.</div> :
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">{products.map((p) => <ProductCard key={p.id} product={p} />)}</div>
      }
    </div>
  );
}
